// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mockup-preview-stores[data-v-48b92cde]{margin:6px 0 0;padding:0;list-style:none;border:1px solid #f2f2f4;height:45px;display:flex;align-items:center;text-align:center;color:#888;border-radius:5px;overflow:hidden}.mockup-preview-stores__item[data-v-48b92cde]{line-height:45px;padding:0 6px;flex:1;cursor:pointer}.mockup-preview-stores__item[data-v-48b92cde]:hover{opacity:.5}.mockup-preview-stores__item--active[data-v-48b92cde]{background-color:#ec8ab3;color:#fff}", ""]);
// Exports
module.exports = exports;
